module.exports = __webpack_public_path__ + "img/magna.c0278eb.png";